/**
 * @generated SignedSource<<52c395f00fca51afcd1ce0bdf7a0d778>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AidsPanelTranslationQuery$variables = {
  language: string;
  turnId: string;
};
export type AidsPanelTranslationQuery$data = {
  readonly node: {
    readonly translation?: {
      readonly id: string;
      readonly language: string;
      readonly text: string;
    } | null | undefined;
  } | null | undefined;
};
export type AidsPanelTranslationQuery = {
  response: AidsPanelTranslationQuery$data;
  variables: AidsPanelTranslationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "turnId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "turnId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "language",
          "variableName": "language"
        }
      ],
      "concreteType": "Translation",
      "kind": "LinkedField",
      "name": "translation",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Turn",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AidsPanelTranslationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "AidsPanelTranslationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "98e24e7feffb0cac3f546a1616f9811a",
    "id": null,
    "metadata": {},
    "name": "AidsPanelTranslationQuery",
    "operationKind": "query",
    "text": "query AidsPanelTranslationQuery(\n  $turnId: ID!\n  $language: String!\n) {\n  node(id: $turnId) {\n    __typename\n    ... on Turn {\n      translation(language: $language) {\n        id\n        language\n        text\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a14004b8032a3a8dd800c4df530ae1d";

export default node;
